import { memo } from "react"
import { cn } from "@/shared/utils/general/cn"
import type { DbObject } from "@/db/schema"
import { useLiveQueryImmediate } from "@/db/hooks"
import { db } from "@/db/schema"
import { humanReadableRule } from "@totodo/operations"

interface RecurrenceLabelProps {
  task: DbObject
  className?: string
}

export const RecurrenceLabel = memo(function RecurrenceLabel({
  task,
  className,
}: RecurrenceLabelProps) {
  const [summary] = useLiveQueryImmediate(
    async () => {
      if (!task.isRecurringTemplate || !task.id) return null
      const rec = await db.recurrence.get(task.id)
      if (!rec) return null
      const text = humanReadableRule(rec.rrule, rec.mode, rec.afterCompletionDays)
      return text
        .replace(/every day/i, "daily")
        .replace(/every week/i, "weekly")
        .replace(/every month/i, "monthly")
        .replace(/every year/i, "yearly")
        .replace(/every (\d+) days?/i, "$1d")
        .replace(/every (\d+) weeks?/i, "$1w")
        .replace(/every (\d+) months?/i, "$1mo")
        .replace(/(\d+) days? after completion/i, "$1d after")
    },
    ["recurrence-label", task.id, task.isRecurringTemplate],
    null,
  )

  if (!summary) return null

  return (
    <span
      className={cn(
        "text-[11px] leading-tight text-foreground/40",
        className,
      )}
    >
      · {summary}
    </span>
  )
})
